import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useState } from 'react';
import { toolbarMessages } from '@atlaskit/editor-common/messages';
import { DropdownMenuWithKeyboardNavigation as DropdownMenu } from '@atlaskit/editor-common/ui-menu';
import { akEditorMenuZIndex } from '@atlaskit/editor-shared-styles';
import { fg } from '@atlaskit/platform-feature-flags';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { DropdownToolbarButton } from './dropdown-toolbar-button';
import { useMenuState } from './hooks/menu-state';
import { MoreButton } from './more-button';
export var FormattingTextDropdownMenu = /*#__PURE__*/React.memo(function (_ref) {
  var _items$0$items$, _items$0$items$2;
  var editorView = _ref.editorView,
    moreButtonLabel = _ref.moreButtonLabel,
    isReducedSpacing = _ref.isReducedSpacing,
    items = _ref.items,
    hasFormattingActive = _ref.hasFormattingActive,
    popupsBoundariesElement = _ref.popupsBoundariesElement,
    popupsMountPoint = _ref.popupsMountPoint,
    popupsScrollableElement = _ref.popupsScrollableElement,
    hasMoreButton = _ref.hasMoreButton,
    intl = _ref.intl,
    toolbarType = _ref.toolbarType,
    shouldUnselect = _ref.shouldUnselect;
  var _useMenuState = useMenuState(),
    _useMenuState2 = _slicedToArray(_useMenuState, 3),
    isMenuOpen = _useMenuState2[0],
    toggleMenu = _useMenuState2[1],
    closeMenu = _useMenuState2[2];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenedByKeyboard = _useState2[0],
    setIsOpenedByKeyboard = _useState2[1];
  var onItemActivated = useCallback(function (_ref2) {
    var item = _ref2.item,
      _ref2$shouldCloseMenu = _ref2.shouldCloseMenu,
      shouldCloseMenu = _ref2$shouldCloseMenu === void 0 ? true : _ref2$shouldCloseMenu;
    if (item) {
      item.command(editorView.state, editorView.dispatch);
      if (shouldCloseMenu) {
        closeMenu();
      }
    }
  }, [editorView.state, editorView.dispatch, closeMenu]);
  var activeItem = items[0].items.find(function (item) {
    return item.isActive;
  });
  var defaultIcon = editorExperiment('platform_editor_controls', 'variant1') && fg('platform_editor_controls_patch_4') ? (_items$0$items$ = items[0].items[0]) === null || _items$0$items$ === void 0 ? void 0 : _items$0$items$.elemBefore : undefined;
  var defaultIconName = (_items$0$items$2 = items[0].items[0]) === null || _items$0$items$2 === void 0 ? void 0 : _items$0$items$2.value.name;
  var iconBefore;
  var activeIconName = defaultIconName;
  if (shouldUnselect && editorExperiment('platform_editor_controls', 'variant1') && fg('platform_editor_controls_patch_7')) {
    iconBefore = defaultIcon;
  } else {
    iconBefore = activeItem ? activeItem === null || activeItem === void 0 ? void 0 : activeItem.elemBefore : defaultIcon;
    activeIconName = (activeItem === null || activeItem === void 0 ? void 0 : activeItem.value.name) || defaultIconName;
  }
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    mountTo: popupsMountPoint,
    onOpenChange: closeMenu,
    boundariesElement: popupsBoundariesElement,
    scrollableElement: popupsScrollableElement,
    onItemActivated: onItemActivated,
    isOpen: isMenuOpen,
    items: items,
    zIndex: akEditorMenuZIndex,
    fitHeight: 188,
    fitWidth: editorExperiment('platform_editor_controls', 'control') ? 136 : 230,
    shouldUseDefaultRole: true,
    section: {
      hasSeparator: true
    },
    shouldFocusFirstItem: function shouldFocusFirstItem() {
      if (isOpenedByKeyboard) {
        setIsOpenedByKeyboard(false);
      }
      return isOpenedByKeyboard;
    }
  }, hasMoreButton ? /*#__PURE__*/React.createElement(MoreButton, {
    isSelected: isMenuOpen || hasFormattingActive,
    label: moreButtonLabel,
    isReducedSpacing: isReducedSpacing,
    isDisabled: false,
    onClick: function onClick() {
      toggleMenu();
      setIsOpenedByKeyboard(false);
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleMenu();
        setIsOpenedByKeyboard(true);
      }
    },
    "aria-expanded": isMenuOpen
  }) : /*#__PURE__*/React.createElement(DropdownToolbarButton, {
    isReducedSpacing: isReducedSpacing,
    isDisabled: false,
    isSelected: isMenuOpen,
    label: intl.formatMessage(toolbarMessages.textFormat),
    "aria-expanded": isMenuOpen,
    "aria-haspopup": true,
    onClick: function onClick() {
      toggleMenu();
      setIsOpenedByKeyboard(false);
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleMenu();
        setIsOpenedByKeyboard(true);
      }
    },
    toolbarType: toolbarType,
    iconBefore: iconBefore,
    activeIconName: activeIconName
  }));
});